<script setup lang="ts">
import { EMIT } from '@/enum';

interface PropsInterface {
  caseManagerName: string;
}

defineProps<PropsInterface>();
const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.ACCEPT): void;
}>();

const onCancel = () => emit(EMIT.CANCEL);
const onAccept = () => emit(EMIT.ACCEPT);
</script>

<template>
  <ConfirmAction
    header="Remove Case Manager"
    class="remove-case-manager-modal"
    :style="{ width: '30rem' }"
    accept-label="Remove Case Manager"
    accept-type="alert"
    @accept="onAccept"
    @cancel="onCancel"
  >
    <div class="flex">
      <Icon name="warning" class="confirm-dialog-icon text-gray-600" />
      <div class="ml-3">
        <p class="remove-notice mb-2">
          Removing
          <b>{{ caseManagerName }}</b>
          from this organization will also remove them from all students in this organization.
        </p>
        <p class="remove-notice">This cannot be undone.</p>
      </div>
    </div>
  </ConfirmAction>
</template>

<style scoped lang="scss">
.remove-case-manager-modal {
  .remove-notice {
    color: $grayDark !important;
  }
}
</style>
